/**
 * Homepage hero photography crossfade.
 * Native opacity rotation only — no carousel library, no slide motion.
 */
(function () {
  'use strict';

  var DEFAULT_INTERVAL = 6000;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function slidesOf(gallery) {
    return gallery.querySelectorAll('.hp-hero__slide');
  }

  function stop(gallery) {
    if (gallery._hpHeroTimer) {
      window.clearInterval(gallery._hpHeroTimer);
      gallery._hpHeroTimer = null;
    }
  }

  function showSlide(gallery, index) {
    var slides = slidesOf(gallery);
    if (!slides.length) return;
    var next = ((index % slides.length) + slides.length) % slides.length;
    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('is-active', i === next);
    }
    gallery._hpHeroIndex = next;
  }

  function activeIndex(gallery) {
    var slides = slidesOf(gallery);
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function start(gallery) {
    stop(gallery);
    var slides = slidesOf(gallery);
    if (slides.length < 2 || prefersReducedMotion()) {
      showSlide(gallery, 0);
      return;
    }

    gallery._hpHeroIndex = activeIndex(gallery);
    var interval = parseInt(gallery.getAttribute('data-interval'), 10) || DEFAULT_INTERVAL;

    gallery._hpHeroTimer = window.setInterval(function () {
      showSlide(gallery, gallery._hpHeroIndex + 1);
    }, interval);
  }

  function galleriesIn(root) {
    if (!root) return [];
    if (root.matches && root.matches('[data-hp-hero-gallery]')) return [root];
    if (!root.querySelectorAll) return [];
    return Array.prototype.slice.call(root.querySelectorAll('[data-hp-hero-gallery]'));
  }

  function init(root) {
    galleriesIn(root || document).forEach(function (gallery) {
      if (gallery.getAttribute('data-hp-gallery-ready') === 'true') return;
      gallery.setAttribute('data-hp-gallery-ready', 'true');
      start(gallery);
    });
  }

  function destroy(root) {
    galleriesIn(root).forEach(function (gallery) {
      stop(gallery);
      gallery.removeAttribute('data-hp-gallery-ready');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var gallery = event.target && event.target.querySelector
      ? event.target.querySelector('[data-hp-hero-gallery]')
      : null;
    if (!gallery) return;
    stop(gallery);
    var blockId = event.detail && event.detail.blockId;
    var slides = slidesOf(gallery);
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-block-id') === blockId) {
        showSlide(gallery, i);
        break;
      }
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var gallery = event.target && event.target.querySelector
      ? event.target.querySelector('[data-hp-hero-gallery]')
      : null;
    if (gallery) start(gallery);
  });

  if (window.matchMedia) {
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var onMotionChange = function (event) {
      galleriesIn(document).forEach(function (gallery) {
        if (event.matches) {
          stop(gallery);
          showSlide(gallery, 0);
        } else {
          start(gallery);
        }
      });
    };
    if (motionQuery.addEventListener) {
      motionQuery.addEventListener('change', onMotionChange);
    } else if (motionQuery.addListener) {
      motionQuery.addListener(onMotionChange);
    }
  }
})();
